function normalizeEnvName(value) {
  return String(value || "")
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .toLowerCase();
}

function readEnv(value, fallback = "") {
  const sanitized = String(value || "")
    .trim()
    .replace(/^['"]|['"]$/g, "");
  return sanitized || fallback;
}

function toBoolean(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  return (
    normalized === "1" ||
    normalized === "true" ||
    normalized === "yes" ||
    normalized === "on"
  );
}

function resolveAppEnv() {
  const explicitEnv = normalizeEnvName(process.env.REACT_APP_ENV);
  if (explicitEnv) return explicitEnv;

  const nodeEnv = normalizeEnvName(process.env.NODE_ENV);
  if (nodeEnv === "production") return "production";
  if (nodeEnv === "development") return "development";

  return "local";
}

const appEnv = resolveAppEnv();

const envMap = {
  local: {
    name: "local",
    apiBaseUrl: readEnv(process.env.REACT_APP_API_BASE_URL),
    cmsAuthBasePath: readEnv(process.env.REACT_APP_CMS_AUTH_BASE_PATH),
    mapboxToken: readEnv(process.env.REACT_APP_MAPBOX_TOKEN),
    mapboxStyle: readEnv(process.env.REACT_APP_MAPBOX_STYLE),
    debugEnv: toBoolean(process.env.REACT_APP_DEBUG_ENV),
  },
  development: {
    name: "development",
    apiBaseUrl: readEnv(process.env.REACT_APP_API_BASE_URL),
    cmsAuthBasePath: readEnv(process.env.REACT_APP_CMS_AUTH_BASE_PATH),
    mapboxToken: readEnv(process.env.REACT_APP_MAPBOX_TOKEN),
    mapboxStyle: readEnv(process.env.REACT_APP_MAPBOX_STYLE),
    debugEnv: toBoolean(process.env.REACT_APP_DEBUG_ENV),
  },
  production: {
    name: "production",
    apiBaseUrl: readEnv(process.env.REACT_APP_API_BASE_URL),
    cmsAuthBasePath: readEnv(process.env.REACT_APP_CMS_AUTH_BASE_PATH),
    mapboxToken: readEnv(process.env.REACT_APP_MAPBOX_TOKEN),
    mapboxStyle: readEnv(process.env.REACT_APP_MAPBOX_STYLE),
    debugEnv: toBoolean(process.env.REACT_APP_DEBUG_ENV),
  },
};

const currentEnv = envMap[appEnv] || envMap.local;

export default currentEnv;
